const { gql } = require('graphql-tag');

const DefaultAddress = require('../fragments/defaultAddress').fragment;

module.exports = {
  fragment: gql`
    ${DefaultAddress}

    fragment ChannelFragment on Channel {
      id
      version
      key
      roles
      name(locale: $locale)
      description(locale: $locale)
      nameAllLocales {
        value
        locale
      }
      descriptionAllLocales {
        value
        locale
      }
      address {
        ...DefaultAddress
      }
    }
  `,
};
